import { render } from "./CardsTable.vue?vue&type=template&id=0f6969dc&scoped=true"
import script from "./CardsTable.vue?vue&type=script&lang=js"
export * from "./CardsTable.vue?vue&type=script&lang=js"

import "./CardsTable.vue?vue&type=style&index=0&id=0f6969dc&scoped=true&lang=css"
import "./CardsTable.vue?vue&type=style&index=1&id=0f6969dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6969dc"]])

export default __exports__